export const consultingOption = {
  gender: {
    type: 'radio',
    options: [
      {
        id: 'gender1',
        name: '여자',
        value: 'F',
      },
      {
        id: 'gender2',
        name: '남자',
        value: 'M',
      },
    ],
  },
  age: {
    type: 'radio',
    options: [
      {
        id: 'age1',
        name: '10대',
        value: '10',
      },
      {
        id: 'age2',
        name: '20대',
        value: '20',
      },
      {
        id: 'age3',
        name: '30대',
        value: '30',
      },
      {
        id: 'age4',
        name: '40대',
        value: '40',
      },
      {
        id: 'age5',
        name: '50대+',
        value: '50',
      },
    ],
  },
};

export const reviewDataTest = [
  {
    id: 1,
    title: 'test',
    starpoint: 3,
    name: '노국현',
    text:
      '오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?',
    date: '2019.07.18 11:30',
    thumbnail: '',
    img: 'http://via.placeholder.com/10000x1000',
    media: '',
  },
  {
    id: 2,
    title: 'test2',
    starpoint: 4,
    name: '조동민',
    text: '컴퓨터는 거짓말 안해',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 3,
    title: 'test2',
    starpoint: 4,
    name: '장래웅',
    text: '흠...',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 4,
    title: 'test2',
    starpoint: 4,
    name: '채윤식',
    text: '벌써부터 침고이네..',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 5,
    title: 'test2',
    starpoint: 4,
    name: '강정묵',
    text: '사진작가입니다.',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 5,
    title: 'test2',
    starpoint: 4,
    name: '한기호',
    text: '31살입니다.',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 1,
    title: 'test',
    starpoint: 3,
    name: '노국현',
    text:
      '오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?',
    date: '2019.07.18 11:30',
    thumbnail: '',
    img: 'http://via.placeholder.com/10000x1000',
    media: '',
  },
  {
    id: 2,
    title: 'test2',
    starpoint: 4,
    name: '조동민',
    text: '컴퓨터는 거짓말 안해',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 3,
    title: 'test2',
    starpoint: 4,
    name: '장래웅',
    text: '흠...',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 4,
    title: 'test2',
    starpoint: 4,
    name: '채윤식',
    text: '벌써부터 침고이네..',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 5,
    title: 'test2',
    starpoint: 4,
    name: '강정묵',
    text: '사진작가입니다.',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 5,
    title: 'test2',
    starpoint: 4,
    name: '한기호',
    text: '31살입니다.',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 1,
    title: 'test',
    starpoint: 3,
    name: '노국현',
    text:
      '오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?오케이 닥터 안녕!?',
    date: '2019.07.18 11:30',
    thumbnail: '',
    img: 'http://via.placeholder.com/10000x1000',
    media: '',
  },
  {
    id: 2,
    title: 'test2',
    starpoint: 4,
    name: '조동민',
    text: '컴퓨터는 거짓말 안해',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 3,
    title: 'test2',
    starpoint: 4,
    name: '장래웅',
    text: '흠...',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 4,
    title: 'test2',
    starpoint: 4,
    name: '채윤식',
    text: '벌써부터 침고이네..',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 5,
    title: 'test2',
    starpoint: 4,
    name: '강정묵',
    text: '사진작가입니다.',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
  {
    id: 5,
    title: 'test2',
    starpoint: 4,
    name: '한기호',
    text: '31살입니다.',
    date: '2019.08.18 12:30',
    thumbnail: '',
    img:
      'https://i.pinimg.com/564x/bb/75/7a/bb757a7abbb6657808f55cefe9c8cafe.jpg',
    media: '',
  },
];
